import { render, staticRenderFns } from "./KPITable.vue?vue&type=template&id=11349b45&scoped=true"
import script from "./KPITable.vue?vue&type=script&lang=js"
export * from "./KPITable.vue?vue&type=script&lang=js"
import style0 from "./KPITable.vue?vue&type=style&index=0&id=11349b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11349b45",
  null
  
)

export default component.exports